import NetworkSvg from "@/public/icon/network";
import SafeSvg from "@/public/icon/safe";
import Svg5g from "@/public/icon/5g";

export const solutionMenuList = [
  {
    title: "安全",
    href: "/solution/sase",
    icon: <SafeSvg className="w-6 h-6" />,
    children: [
      { key: "sase", title: "SASE多云安全接入", href: "/solution/sase" },
      { key: "protect", title: "应用APP防护", href: "/solution/protect" },
      { key: "access", title: "小程序接入", href: "/solution/access" },
      {
        key: "isolate",
        title: "东西向微隔离防护",
        href: "/solution/isolate",
      },
      {
        key: "networking",
        title: "企业全连接安全组网",
        href: "/solution/networking",
      },
      { key: "work", title: "企业统一办公门户", href: "/solution/work" },
    ],
  },
  {
    title: "网络",
    icon: <NetworkSvg className="w-6 h-6" />,
    href: "/solution/lifecycle",
    children: [
      {
        key: "lifecycle",
        title: "IP地址全生命周期管理",
        href: "/solution/lifecycle",
      },
      { key: "domain", title: "企业域名化改造", href: "/solution/domain" },
      { key: "operation", title: "自动化运维", href: "/solution/operation" },
    ],
  },
  {
    title: "5G",
    href: "/solution/5g",
    icon: <Svg5g className="w-6 h-6" />,
    children: [{ key: "5g", title: "5G安全接入", href: "/solution/5g" }],
  },
];

export const solutionKeyMap = {};

export const solutionInfo = [
  // 安全
  {
    title: "SASE多云安全接入",
    key: "sase",
    descInfo: {
      title: "SASE多云安全接入",
      desc: "基于SASE多云安全接入，通过零信任安全实现多维度一体化防御管控，将身份、终端、通信、网络、应用等维度一体化安全控制，通过统一的安全策略编排、多云多网络平面的安全管控、安全能力移动化，打造接入即安全的服务化能力，解决高成本复杂安全接入保护难题。",
      img: "/solution/desc0.png",
    },
    problemList: [
      {
        title: "业务暴露",
        desc: "VPN、互联网业务等存在大量暴露面",
        img: "/solution/sase/problem1.png",
      },
      {
        title: "0day攻击",
        desc: "各类业务和安全工具0day漏洞难防范",
        img: "/solution/sase/problem2.png",
      },
      {
        title: "安全防护难",
        desc: "多云、移动办公等导致安全能力无法全面覆盖",
        img: "/solution/sase/problem3.png",
      },
    ],
    coreadvList: [
      { title: "接入即安全", img: "/solution/sase/coreadv1.png" },
      { title: "多维度安全", img: "/solution/sase/coreadv2.png" },
      { title: "零信任防护", img: "/solution/sase/coreadv3.png" },
    ],
    customerList: ["移动办公客户", "云网建设客户"],
  },
  {
    title: "应用APP防护",
    key: "protect",
    descInfo: {
      title: "应用APP防护",
      desc: "应用APP防护提供安全接入SDK组件，可以轻松将安全接入能力集成到应用程序中，安全接入SDK可为应用程序开发者提供全面的安全保护，包括网络隐身、身份验证、数据加密、设备可信验证、动态授权。通过集成SDK到APP开发中，确保应用程序的安全性和可靠性。",
      img: "/solution/desc3.png",
    },
    problemList: [
      {
        title: "网络暴露面攻击",
        desc: "APP服务入口长期遭受攻击",
        img: "/solution/protect/problem1.png",
      },
      {
        title: "业务通信无保护",
        desc: "接口基于http协议传输无保护",
        img: "/solution/protect/problem2.png",
      },
      {
        title: "APP漏洞多",
        desc: "业务开发商安全能力不高业务漏洞多",
        img: "/solution/protect/problem3.png",
      },
    ],
    coreadvList: [
      { title: "APP业务隐身", img: "/solution/protect/coreadv1.png" },
      { title: "SDK快速封装", img: "/solution/protect/coreadv2.png" },
      { title: "应用级保护", img: "/solution/protect/coreadv3.png" },
    ],
    customerList: ["政府", "在线教育", "APP厂商"],
  },
  {
    title: "小程序安全接入",
    key: "access",
    descInfo: {
      title: "小程序安全接入",
      desc: "只需修改一行代码，小程序安全接入面向微信、企业微信的所有小程序、H5、公众号等提供网络隐身防护以及访问过程安全加固，提供防爬虫、业务防刷、防DDoS攻击、HTTP通信加密防护、防DNS劫持、弱网加速、流量治理等更快速、更安全、更稳定的安全防护服务。",
      img: "/solution/desc4.png",
    },
    problemList: [
      {
        title: "攻击增多",
        desc: "企业运营小程序、H5风险攻击越来越多，服务不安全",
        img: "/solution/access/problem1.png",
      },
      {
        title: "业务盗刷",
        desc: "薅羊毛等对业务进行盗刷，损坏业务正常商业模式",
        img: "/solution/access/problem2.png",
      },
      {
        title: "数据劫持",
        desc: "部分业务基于http明文传输导致数据劫持事件发生",
        img: "/solution/access/problem3.png",
      },
    ],
    coreadvList: [
      { title: "一行代码改造", img: "/solution/access/coreadv1.png" },
      { title: "网络隐身", img: "/solution/access/coreadv2.png" },
      { title: "业务防刷", img: "/solution/access/coreadv3.png" },
    ],
    customerList: ["企业微信用户", "微信小程序用户", "H5用户"],
  },
  {
    title: "东西向微隔离防护",
    key: "isolate",
    descInfo: {
      title: "东西向微隔离防护",
      desc: "对企业多重网络下的各类跨系统架构的资产（如不同操作系统的物理机、虚拟机、容器）实现通信行为可视化测绘和呈现，了解业务通信关系，同时借助微隔离最小化隔离能力，实现业务端到端的自适应隔离策略自动化管控，减少运维难度和工作量，提升安全管控级别。",
      img: "/solution/desc0.png",
    },
    problemList: [
      {
        title: "资产通信不明",
        desc: "无法感知各类资产通信行为是否合规",
        img: "/solution/isolate/problem1.png",
      },
      {
        title: "跨架构管理难",
        desc: "各类虚拟机、容器跨形态跨架构难管理",
        img: "/solution/isolate/problem2.png",
      },
      {
        title: "无安全隔离能力",
        desc: "云内、VLAN内部资产无隔离策略",
        img: "/solution/isolate/problem3.png",
      },
    ],
    coreadvList: [
      { title: "通信可视化", img: "/solution/isolate/coreadv1.png" },
      { title: "实施自动化", img: "/solution/isolate/coreadv2.png" },
      { title: "策略最小化", img: "/solution/isolate/coreadv3.png" },
    ],
    customerList: ["具备大量主机/虚拟机/容器资产的单位"],
  },
  {
    title: "企业全连接安全组网",
    key: "networking",
    descInfo: {
      title: "企业全连接安全组网",
      desc: "赛讯为客户提供各种全连接泛在接入场景下的安全组网能力，覆盖分支组网、加速访问、物联网、园区互联、上云等需求，通过全连接安全组网，可以提供业务网络隐身收敛、基于互联网组建跨区域安全专网、基于用户身份精细化安全管控，并提供mCPE、5G CPE、标准CPE等产品形态。",
      img: "/solution/desc0.png",
    },
    problemList: [
      {
        title: "业务跨网访问",
        desc: "多重网络难控制，网络边界破坏严重",
        img: "/solution/networking/problem1.png",
      },
      {
        title: "业务暴露面",
        desc: "互联网、内部区域网络有大量暴露面风险",
        img: "/solution/networking/problem2.png",
      },
      {
        title: "专线组网昂贵",
        desc: "跨区域多节点购买专线组网过于昂贵",
        img: "/solution/networking/problem3.png",
      },
    ],
    coreadvList: [
      { title: "组网灵活化", img: "/solution/networking/coreadv1.png" },
      { title: "安全能力多", img: "/solution/networking/coreadv2.png" },
      { title: "适应场景广", img: "/solution/networking/coreadv3.png" },
    ],
    customerList: ["政府、运营商、工业园区客户"],
  },
  {
    title: "企业统一办公门户",
    key: "work",
    descInfo: {
      title: "企业统一办公门户",
      desc: "通过企业统一安全浏览器可建立一个统一办公门户，实现统一业务发布、统一身份、统一访问、可调度编排安全策略的浏览器访问入口。同时可提供多项安全增值能力协助安全、便捷办公。并可提供多样化增值扩展能力、策略可统一编排控制、统筹管理、可运营能力，实现云-网-边-端一体化防御，保障终端访问和业务服务安全！ CPE、标准CPE等产品形态。",
      img: "/solution/desc7.png",
    },
    problemList: [
      {
        title: "",
        desc: "业务访问入口众多， 不具备可统一调度编排的办公入口",
        img: "/solution/work/problem1.png",
      },
      {
        title: "",
        desc: "普通浏览器不具备安全防护能力，安全风险难以管控",
        img: "/solution/work/problem2.png",
      },
      {
        title: "",
        desc: "应用国密改造后普通浏览器无法访问，需依赖插件",
        img: "/solution/work/problem3.png",
      },
    ],
    coreadvList: [
      { title: "统一办公门户", img: "/solution/work/coreadv1.png" },
      { title: "统一安全管理", img: "/solution/work/coreadv2.png" },
      { title: "国密应用适配", img: "/solution/work/coreadv3.png" },
    ],
    customerList: ["政府、运营商、企业"],
  },
  // 网络
  {
    title: "IP地址全生命周期管理",
    key: "lifecycle",
    descInfo: {
      title: "IP地址全生命周期管理",
      desc: "建立IP地址全生命周期管理，从地址资产规划拆分开始按业务、区域、类型等划分地址资产，构建地址资产规划使用流程管理，实现地址申请、地址工单上报、工单审批、资产自动化下发、使用、回收、分权分域管控自有网段，从而形成一体化的全流程管控能力。",
      img: "/solution/desc8.png",
    },
    problemList: [
      {
        title: "",
        desc: "缺乏有效地址规划",
        img: "/solution/lifecycle/problem1.png",
      },
      {
        title: "",
        desc: "手工管理容易造成IP地址冲突",
        img: "/solution/lifecycle/problem2.png",
      },
      {
        title: "",
        desc: "地址不能及时回收造成浪费",
        img: "/solution/lifecycle/problem3.png",
      },
    ],
    coreadvList: [
      { title: "动静态IP统一管理", img: "/solution/lifecycle/coreadv1.png" },
      { title: "多维度智能分配", img: "/solution/lifecycle/coreadv2.png" },
      { title: "友好图形化界面", img: "/solution/lifecycle/coreadv3.png" },
    ],
    customerList: ["政府、运营商、学校、企业"],
  },
  {
    title: "企业域名化改造",
    key: "domain",
    descInfo: {
      title: "IP地址全生命周期管理",
      desc: "资源域名化：建立授权管控能力，为用户的IP业务地址提供给域名解析授权服务，权威服务配置和管理DNS的域和域名记录数据。业务不中断：为用户提供域名全流程管控配置能力，域名化资源，解决业务割接、灰度测试、IP变动、系统扩容等因素对业务的影响。域名解析安全：可以实施安全性控制措施，如设置访问控制列表或防火墙规则，限制对特定域名的解析访问。",
      img: "/solution/desc9.png",
    },
    problemList: [
      {
        title: "用户友好性差",
        desc: "IP地址难以记忆，对用户来说不够友好，可能导致输入错误或混淆",
        img: "/solution/domain/problem1.png",
      },
      {
        title: "品牌识别困难",
        desc: "缺少域名可能会使企业的在线形象和品牌识别度受到限制",
        img: "/solution/domain/problem2.png",
      },
      {
        title: "安全性风险",
        desc: "直接使用IP地址访问应用可能暴露服务器信息，增加潜在的安全风险",
        img: "/solution/domain/problem3.png",
      },
    ],
    coreadvList: [
      { title: "域名安全防护", img: "/solution/domain/coreadv1.png" },
      { title: "可扩展性高", img: "/solution/domain/coreadv2.png" },
      { title: "IPv4与IPv6双栈支持", img: "/solution/domain/coreadv3.png" },
    ],
    customerList: ["企业"],
  },
  {
    title: "自动化运维",
    key: "operation",
    descInfo: {
      title: "IP地址全生命周期管理",
      desc: "资产采集、实时监控度量、自动化任务、警报通知、审计合规和历史数据分析构成了全面的自动化运维体系。通过采集各系统设备数据，实时监控状态，执行自动化任务，发现问题并通知团队，记录运维操作，数据分析，这六大功能协同工作，为确保系统健康、提升运营效率和智能决策提供了全方位的帮助。",
      img: "/solution/desc0.png",
    },
    problemList: [
      {
        title: "手工操作和重复性工作",
        desc: "运维人员需要频繁执行手动操作，容易出错且耗时繁琐",
        img: "/solution/operation/problem1.png",
      },
      {
        title: "人为错误",
        desc: "手动操作容易导致配置错误、网络问题和应用故障，增加故障排除负担",
        img: "/solution/operation/problem2.png",
      },
      {
        title: "延迟和响应不及时",
        desc: "依赖手动操作导致故障修复时间延长，影响系统可用性",
        img: "/solution/operation/problem3.png",
      },
    ],
    coreadvList: [
      { title: "多数据采集", img: "/solution/operation/coreadv1.png" },
      { title: "可视化管理", img: "/solution/operation/coreadv2.png" },
      { title: "自动化运维", img: "/solution/operation/coreadv3.png" },
    ],
    customerList: ["政府、运营商、大型企业"],
  },
  // 5G
  {
    title: "5G安全接入",
    key: "5g",
    descInfo: {
      title: "5G安全接入",
      desc: "融合5G技术以及零信任安全技术，可以实现5G专网与互联网之间的双网管控，防止专网业务暴露面攻击，可以实现5G用户无感接入，可以根据5G用户身份进行精细化、动态化授权准入，并且在５G用户变动后及时变更权限，防范权限蔓延；过程中提供访问业务的审计溯源记录，提升安全能力。",
      img: "/solution/desc2.png",
    },
    problemList: [
      {
        title: "5G专网暴露面",
        desc: "5G专网存在大量暴露面，威胁风险加大",
        img: "/solution/5g/problem1.png",
      },
      {
        title: "5G专网管控难",
        desc: "5G用户可访问专网所有业务，人员流转无管控",
        img: "/solution/5g/problem2.png",
      },
      {
        title: "业务访问无审计",
        desc: "5G专网访问无有效审计，安全事件溯源难",
        img: "/solution/5g/problem3.png",
      },
    ],
    coreadvList: [
      { title: "5G无感安全访问", img: "/solution/5g/coreadv1.png" },
      { title: "精细化权限控制", img: "/solution/5g/coreadv2.png" },
      { title: "５G专网防护", img: "/solution/5g/coreadv3.png" },
    ],
    customerList: ["运营商5G用户"],
  },
];
